export default __webpack_public_path__ + "static/media/capsule-removed.95932fe6.png";